import { render, staticRenderFns } from "./CardLists.vue?vue&type=template&id=4ba64211"
import script from "./CardLists.vue?vue&type=script&lang=js"
export * from "./CardLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports